import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import TableSortingTypesDIVehicles from './SortingTablesTypesDIVehicles'; 
import PropTypes from 'prop-types'; 
 
const initialStateVehicles = [{
  "id":0, 
  "licenseplate":"",
  "defaultvehicle":false,
  "tara":0,
  "pma":0,
  "checkpma":false,
  "defaultdriver":"",
  "enabled":true

}];
        

const TypesDISearchVehicles = ({ showModalSearchVehicles, setShowModalSearchVehicles,selectStores,setFormForm,titleTable,store_id}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataVehicle, setDataVehicle] = useState(initialStateVehicles);
  const [numTotRegVehicles,setNumTotRegVehicles]= useState(0); 
  
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
     
      if (e.key === 'Escape' && showModalSearchVehicles) {
        setDataVehicle(initialStateVehicles);
        setNumTotRegVehicles(0);
        setShowModalSearchVehicles(false);
      }
    },
    [ setDataVehicle,
      setNumTotRegVehicles,
      showModalSearchVehicles,
      setShowModalSearchVehicles
    ]
  );

  const handleCloseDataEditVehicles = () => {
    setDataVehicle(initialStateVehicles);
    setNumTotRegVehicles(0);
    setShowModalSearchVehicles(false);
	};

  const toggleDrawerSearchFormVehicles  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditVehicles();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
       
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegVehicles = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `typesdi/getinformationtablestorevehicles/`, token,(store_id!==null && store_id!=="" && store_id!=="0" && store_id!==0)?store_id:"-1");
        if (getData.err) {
          setDataVehicle(initialStateVehicles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegVehicles(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchDataVehicles = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`typesdi/getvehiclesstoresbystoreid/`,token,(store_id!==null && store_id!=="" && store_id!=="0" && store_id!==0)?store_id:"-1");
        if (getData.err || getData.message === "Load failed") {
          setDataVehicle(initialStateVehicles);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataVehicle(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    
    if (showModalSearchVehicles){
      fetchnumTotRegVehicles(); 
      fetchDataVehicles();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,showModalSearchVehicles,store_id]);
 
  return(
    <>
      {showModalSearchVehicles && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormVehicles(false)}
            onOpen={toggleDrawerSearchFormVehicles(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {t('Text_FORM_Stores_Vehicles_Search')}
                  </h1>
                  <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataEditVehicles} >{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>
                <div className="formdi-pending-card-flat">
                  <div className="formdi-pending-card-content">
                    <TableSortingTypesDIVehicles
                      dataVehicle={dataVehicle}
                      numTotRegVehicles={numTotRegVehicles}
                      titleTable={titleTable}
                      selectStores={selectStores}
                      setFormForm={setFormForm}
                      handleCloseDataEditVehicles={handleCloseDataEditVehicles}
                    />
                  </div>             
                </div>
                {/* End Content Row */}                
              </Box>
            </Container>
          </SwipeableDrawer> 
        </div>
      }  
    </>
  )
}

TypesDISearchVehicles.propTypes = {
  showModalSearchVehicles : PropTypes.bool.isRequired,
  setShowModalSearchVehicles : PropTypes.func.isRequired,
  selectStores : PropTypes.string.isRequired,
  setFormForm : PropTypes.func.isRequired,
  titleTable : PropTypes.string.isRequired
};

export default TypesDISearchVehicles;
